import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P46-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page46/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Circle the odd-one-out. Write.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['store', 'computer room', 'balloon', 'read'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { margin: '5px', border: 'solid 2px', borderColor: 'black', borderRadius: 10, padding: '0 5px', backgroundColor: 'white' },
        selectWordStyle: { borderColor: '#00a8ec' },
        limitSelect: 1,
        listWords: [
          'morning store afternoon evening', //0
          'nuts computer_room candy cake', //1
          'get_up go_to_school go_home balloon', //2
          'read music math English', //3
        ],
        answers: ['0-2', '1-2', '2-6', '3-0'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: rgb(255, 252, 205); padding: 20px;'>
          <div style='margin: 5px;'><b>1</b>
            <span style='margin: 10px 20px; border: 2px solid rgb(0, 168, 236); border-radius: 10px; padding: 5px 10px; background-color: white;'>music</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>salad</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>noodles</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>pizza</span>
            <span><u style='text-decoration-color: black;color:rgb(82,197,235)'>&emsp;music.&emsp;</u></span>
          </div>
          <div><span style='display:flex;justify-content: space-between; width: 750px;align-items: center;'><b>2</b> <input id='0' type='Circle' /> <input id='0' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 750px;align-items: center;'><b>3</b> <input id='1' type='Circle' /> <input id='1' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 750px;align-items: center;'><b>4</b> <input id='2' type='Circle' /> <input id='2' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 750px;align-items: center;'><b>5</b> <input id='3' type='Circle' /> <input id='3' /></span> </div>
        </div>
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P46-E2',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page46/E2/Key/answerKey.png',
    titleQuestion: [{ num: '2', title: 'Read and circle.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%', fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        limitSelect: 1,
        listWords: [
          'doesn’t_like / don’t_like',//1
          'doesn’t_like / don’t_like',//2
          'like / likes',//3
          'likes / like',//4
          'doesn’t_like / don’t_like',//5
        ],
        answers: ['0-4', '1-0', '2-4', '3-0', '4-0'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: rgb(255, 252, 205); padding: 20px;'>
          <img src="img/FriendsPlus/Page46/E2/1.jpg" style="width: 100%" />
          <div style='margin-left: 20px;'>
            <div><b>1</b>&nbsp;My name is Danni. I <span style='font-weight: bold;'><span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">like</span> / likes</span> balloons.</div>
            <div><b>2</b>&ensp;I <input id='0' type='Circle' /> nuts or sweets.</div>
            <div><b>3</b>&ensp;This is my brother, Hal. He <input id='1' type='Circle' /> candy or cakes.</div>
            <div><b>4</b>&ensp;He <input id='2' type='Circle' /> bananas and nuts.</div>
            <div><b>5</b>&ensp;My mom <input id='3' type='Circle' /> nuts and cakes.</div>
            <div><b>6</b>&ensp;She <input id='4' type='Circle' /> balloons.</div>
          </div>
        </div>
      `,
    },
  },
  3: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P46-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page46/E3/1.jpg' }]],
  },
}

export default json;